"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Players_module_css_1 = __importDefault(require("./Players.module.css"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_i18next_1 = require("react-i18next");
var q_play_components_2 = require("@nordicscreen/q-play-components");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var react_bootstrap_1 = require("react-bootstrap");
var AddMetadataModal = function (_a) {
    var isShown = _a.isShown, toggle = _a.toggle, player = _a.player, setPlayerDetailsModalShown = _a.setPlayerDetailsModalShown;
    var defaultSavingState = { saving: false, saved: false, text: "" };
    var _b = (0, react_1.useState)(defaultSavingState), savingState = _b[0], setSavingState = _b[1];
    var _c = (0, react_1.useState)([]), metadata = _c[0], setMetadata = _c[1];
    var _d = (0, react_1.useState)({}), selectedKeyValuePairs = _d[0], setSelectedKeyValuePairs = _d[1];
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _e = (0, react_1.useState)([]), attachedMetadata = _e[0], setAttachedMetadata = _e[1];
    var _f = (0, react_1.useState)([]), activeKeys = _f[0], setActiveKeys = _f[1];
    var logger = q_play_core_1.logManager.getLogger();
    var loadPlayerMetadata = function () { return __awaiter(void 0, void 0, void 0, function () {
        var metadataPromise, playerMetadataPromise, _a, metadata_1, attachedMetadata_1, formattedMetadata, formattedAttachedMetadata, initialSelectedKeyValuePairs, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    metadataPromise = ApiManager_1.default.getMetadata();
                    playerMetadataPromise = ApiManager_1.default.getPlayerMetadata(player.id);
                    return [4 /*yield*/, Promise.all([metadataPromise, playerMetadataPromise])];
                case 1:
                    _a = _b.sent(), metadata_1 = _a[0], attachedMetadata_1 = _a[1];
                    formattedMetadata = metadata_1.map(function (item) {
                        var parsedMeta = {};
                        try {
                            parsedMeta = typeof item.key_value_pairs === "string" ? JSON.parse(item.key_value_pairs) : item.key_value_pairs;
                        }
                        catch (e) {
                            logger.error("Error parsing metadata:", e);
                        }
                        return __assign(__assign({}, item), { key_value_pairs: parsedMeta });
                    });
                    formattedAttachedMetadata = attachedMetadata_1.metadata.map(function (item) { return (__assign(__assign({}, item), { metadata: item.keys && item.keys !== "[]" ? JSON.parse(item.keys) : {} })); });
                    initialSelectedKeyValuePairs = formattedAttachedMetadata.reduce(function (acc, item) {
                        if (item.metadata_id && item.metadata) {
                            acc[item.metadata_id.toString()] = item.metadata;
                        }
                        return acc;
                    }, {});
                    setMetadata(formattedMetadata);
                    setAttachedMetadata(formattedAttachedMetadata);
                    setSelectedKeyValuePairs(initialSelectedKeyValuePairs);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    logger.error("Error fetching metadata for player:" + player.id, error_1);
                    setMetadata([]);
                    setAttachedMetadata([]);
                    setSelectedKeyValuePairs({});
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getAttachedMetadata = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, formattedMetadata, initialSelectedKeyValuePairs, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.getPlayerMetadata(player.id)];
                case 1:
                    response = _a.sent();
                    formattedMetadata = response.metadata.map(function (item) { return (__assign(__assign({}, item), { metadata: item.keys && item.keys !== "[]" ? JSON.parse(item.keys) : {} })); });
                    setAttachedMetadata(formattedMetadata);
                    initialSelectedKeyValuePairs = formattedMetadata.reduce(function (acc, item) {
                        if (item.metadata_id && item.metadata) {
                            acc[item.metadata_id.toString()] = item.metadata;
                        }
                        return acc;
                    }, {});
                    setSelectedKeyValuePairs(initialSelectedKeyValuePairs);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    logger.error("Error fetching player metadata:", error_2);
                    setAttachedMetadata([]);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (isShown) {
            loadPlayerMetadata();
        }
        else {
            setMetadata([]);
            setAttachedMetadata([]);
            setSelectedKeyValuePairs({});
            setSavingState(defaultSavingState);
        }
    }, [isShown, player]);
    var handleBackNavigation = function () {
        toggle();
        setPlayerDetailsModalShown(true);
    };
    (0, react_1.useEffect)(function () {
        if (attachedMetadata.length > 0) {
            var initialSelectedKeyValuePairs = attachedMetadata.reduce(function (acc, item) {
                if (item.metadata_id && item.metadata) {
                    acc[item.metadata_id.toString()] = item.metadata;
                }
                return acc;
            }, {});
            setSelectedKeyValuePairs(initialSelectedKeyValuePairs);
        }
    }, [attachedMetadata]);
    (0, react_1.useEffect)(function () {
        if (metadata.length > 0) {
            var keys = metadata.map(function (meta) { return meta.id.toString(); });
            setActiveKeys(keys);
        }
    }, [metadata]);
    var handleAccordionToggle = function (idKey) {
        setActiveKeys(function (prevKeys) {
            return prevKeys.includes(idKey)
                ? prevKeys.filter(function (key) { return key !== idKey; })
                : __spreadArray(__spreadArray([], prevKeys, true), [idKey], false);
        });
    };
    var handleKeyValuePairSelection = function (idKey, key, value) {
        setSelectedKeyValuePairs(function (prevSelectedKeyValuePairs) {
            var updatedKeyValuePairs = __assign({}, prevSelectedKeyValuePairs);
            if (!updatedKeyValuePairs[idKey]) {
                updatedKeyValuePairs[idKey] = {};
            }
            if (Object.keys(updatedKeyValuePairs[idKey]).includes(key)) {
                delete updatedKeyValuePairs[idKey][key];
                if (Object.keys(updatedKeyValuePairs[idKey]).length === 0) {
                    delete updatedKeyValuePairs[idKey];
                }
            }
            else {
                updatedKeyValuePairs[idKey][key] = value;
            }
            return updatedKeyValuePairs;
        });
    };
    var addPlayerMetadata = function () { return __awaiter(void 0, void 0, void 0, function () {
        var logger_1, playerId, formattedMetadata, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!player) return [3 /*break*/, 4];
                    logger_1 = q_play_core_1.logManager.getLogger();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    playerId = player.id;
                    formattedMetadata = Object.entries(selectedKeyValuePairs).map(function (_a) {
                        var idKey = _a[0], keyValuePairs = _a[1];
                        var metadataId = parseInt(idKey, 10);
                        var metadataItem = metadata.find(function (meta) { return meta.id === metadataId; });
                        if (!metadataItem || Object.keys(keyValuePairs).length === 0) {
                            return null;
                        }
                        return {
                            id: metadataId,
                            keys: JSON.stringify(keyValuePairs)
                        };
                    }).filter(Boolean);
                    return [4 /*yield*/, ApiManager_1.default.syncMetadataToPlayer(playerId, formattedMetadata)];
                case 2:
                    _a.sent();
                    setSavingState(__assign(__assign({}, defaultSavingState), { saved: true, text: "Metadata added successfully" }));
                    getAttachedMetadata();
                    toggle();
                    setPlayerDetailsModalShown(true);
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    logger_1.error("Error adding player metadata:", error_3);
                    setSavingState(__assign(__assign({}, defaultSavingState), { saved: false, text: "Error adding metadata" }));
                    toggle();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var renderKeyValuePairs = function (idKey, keyValuePairs) {
        if (!keyValuePairs) {
            return null;
        }
        var displayObject;
        if (Array.isArray(keyValuePairs)) {
            displayObject = keyValuePairs.reduce(function (acc, item) {
                acc[item] = item;
                return acc;
            }, {});
        }
        else {
            displayObject = keyValuePairs;
        }
        var entriesWithValidKeys = Object.entries(displayObject);
        if (entriesWithValidKeys.length === 0) {
            return null;
        }
        return (react_1.default.createElement("div", { className: Players_module_css_1.default.accordion_body_container, style: { padding: "unset", marginBottom: "0.65em" } },
            react_1.default.createElement("div", { className: Players_module_css_1.default["available-metadata"] }, entriesWithValidKeys.map(function (_a, index) {
                var key = _a[0], value = _a[1];
                var isSelected = selectedKeyValuePairs[idKey]
                    ? Object.keys(selectedKeyValuePairs[idKey]).includes(key)
                    : false;
                return (react_1.default.createElement(react_1.default.Fragment, { key: "".concat(idKey, "-").concat(key) },
                    react_1.default.createElement("div", { onClick: function () { return handleKeyValuePairSelection(idKey, key, value); }, "data-cy": "metadataKeyValuePair", style: {
                            cursor: "pointer",
                            borderRadius: "3px",
                            backgroundColor: isSelected
                                ? "var(--secondary-color-tinted)"
                                : "transparent",
                            outline: isSelected
                                ? "2px var(--primary-color) solid"
                                : "none",
                            padding: "6px",
                            color: "var(--info-color)",
                            fontSize: "1.3rem",
                        } },
                        key,
                        ": ",
                        value),
                    index < entriesWithValidKeys.length - 1 && (react_1.default.createElement("span", { className: Players_module_css_1.default.separator }))));
            }))));
    };
    return (react_1.default.createElement(q_play_components_2.Modal, { isShown: isShown, onClose: toggle, dialogClassName: Players_module_css_1.default.modalDialog, centered: true, dataCy: "addMetadataModal", body: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: Players_module_css_1.default.add_presentation_modal_header },
                react_1.default.createElement(q_play_components_1.Button, { className: "p-0", style: { minWidth: "50px" }, variant: "empty", onClick: handleBackNavigation },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAngleLeft, color: "var(--primary-color)", size: "2x" })),
                react_1.default.createElement("span", null, t("Add metadata")),
                react_1.default.createElement("div", { className: Players_module_css_1.default.group_name_container },
                    react_1.default.createElement(react_bootstrap_1.Accordion, { activeKey: activeKeys, alwaysOpen: true }, metadata.map(function (metadataItem) {
                        var idKey = metadataItem.id.toString();
                        return (react_1.default.createElement(react_bootstrap_1.Accordion.Item, { key: idKey, eventKey: idKey, className: Players_module_css_1.default.accordion_item_container, style: { marginLeft: "1.2em", marginRight: "1.2em" } },
                            react_1.default.createElement(react_bootstrap_1.Accordion.Header, { className: "".concat(Players_module_css_1.default.accordion_header_container, " ").concat(Players_module_css_1.default.accordion_header_container_button), "data-cy": "accordionHeader", onClick: function () { return handleAccordionToggle(idKey); } },
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement("label", { className: Players_module_css_1.default.group_name },
                                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAngleDown, style: { marginRight: "10px", fontSize: "16px" } }),
                                        metadataItem.meta_key))),
                            react_1.default.createElement(react_bootstrap_1.Accordion.Body, { className: "p-0" }, renderKeyValuePairs(idKey, metadataItem.key_value_pairs))));
                    })))),
            react_1.default.createElement("div", { className: "d-flex justify-content-end mt-4" },
                savingState.saved &&
                    react_1.default.createElement("span", { style: { fontFamily: "Geomanist", margin: "auto 1rem" } }, t(savingState.text)),
                react_1.default.createElement(q_play_components_1.Button, { text: t("Add metadata"), size: "small", dataCy: "attachMetadataButton", onClick: addPlayerMetadata, isDisabled: savingState.saving || Object.keys(selectedKeyValuePairs).length === 0 }))) }));
};
exports.default = AddMetadataModal;
